import { useEffect, useState } from "react";
import apiFactory from "../../api";
import WelcomeCarosel from "../../components/carousel/WelcomeCarosel";
import { useSideBarStore } from "../../store/SideBarStore";
import { useInfoUser } from "../../store/UserStore";

export const Welcome = () => {
  const { languageMap } = useInfoUser();
  const [welcomeTemplates, setWelcomeTemplates] = useState([]);

  const getActiveTemplate = async () => {
    try {
      const welcomeTemplates = await apiFactory.welcomeSlideApi.getTemplate();
      if (welcomeTemplates?.status !== 200) {
        console.error("Failed to fetch welcome templates");
      }
      setWelcomeTemplates(welcomeTemplates?.data || []);
    } catch (error) {
      console.error("Error fetching welcome templates:", error);
    }
  };

  useEffect(() => {
    getActiveTemplate();
  }, []);

  return (
    <div className={`welcome`}>
      <WelcomeCarosel
        slides={welcomeTemplates?.slides}
        musicResourceId={welcomeTemplates?.musicResourceId}
        autoPlayMusic={welcomeTemplates?.autoPlayMusic}
      />
    </div>
  );
};
